import { render } from "./ProductDetailsPage.vue?vue&type=template&id=bc2f0d46"
import script from "./ProductDetailsPage.vue?vue&type=script&lang=js"
export * from "./ProductDetailsPage.vue?vue&type=script&lang=js"

import "./ProductDetailsPage.vue?vue&type=style&index=0&id=bc2f0d46&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__